module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"PersDaten":"Personen-Daten","male":"männlich","female":"weiblich","height":"Körpergröße","weight":"Körpergewicht","comp":"Berechnungen","bodydata":"Körperdaten","tidal":"Tidalvolumen"},"en":{"PersDaten":"Patient Data","male":"male","female":"female","height":"Body Size","weight":"Bodyweight","comp":"Calculation","bodydata":"Body Data","tidal":"Tidal Volume"}}')
  delete Component.options._Ctor
}
